var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#703FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 44.36L56 38C56 31.3726 50.6274 26 44 26L37.64 26C31.0126 26 25.64 31.3726 25.64 38L25.64 44.36C25.64 50.9874 31.0126 56.36 37.64 56.36L44 56.36C47.1826 56.36 50.2348 55.0957 52.4853 52.8453C54.7357 50.5948 56 47.5426 56 44.36ZM38 47.36L32.555 41.915C32.1163 41.4758 32.1163 40.7642 32.555 40.325L37.985 34.94C38.4283 34.527 39.119 34.5391 39.5474 34.9676C39.9758 35.396 39.988 36.0867 39.575 36.53L34.925 41.18L39.575 45.83C40.0137 46.2692 40.0137 46.9808 39.575 47.42C39.3661 47.6344 39.0794 47.7554 38.78 47.7554C38.4806 47.7554 38.1939 47.6344 37.985 47.42L38 47.36ZM41.75 46.565C41.7535 46.8626 41.8717 47.1474 42.08 47.36L42.065 47.42C42.2739 47.6344 42.5606 47.7554 42.86 47.7554C43.1594 47.7554 43.4461 47.6344 43.655 47.42L49.1 41.975C49.3144 41.7661 49.4354 41.4794 49.4354 41.18C49.4354 40.8806 49.3144 40.5939 49.1 40.385L43.655 34.94C43.2117 34.527 42.521 34.5391 42.0926 34.9676C41.6641 35.396 41.652 36.0867 42.065 36.53L46.715 41.18L42.08 45.77C41.8742 45.9843 41.7565 46.268 41.75 46.565Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.b1ac96ba129835aa34c816bb64eafd60.svg";
export { ForwardRef as ReactComponent };